module.exports = __webpack_public_path__ + "img/sales order.fd9b7057.png";